import Image from 'next/image'
import TryCenteredButton from '../shared/TryCenteredButton'
import PreviewImage from './app-image.jpg'

export default function HoneyPotPreview(): JSX.Element {
  return (
    <div
      className="flex flex-col md:flex-row gap-16 p-12 rounded-lg relative overflow-hidden mt-10"
      style={{
        backgroundColor: '#272727',
      }}
    >
      <div className="flex flex-col justify-between">
        <div className="text-white text-opacity-60 text-xl mb-8">
          <p className="mb-8">
            Never have another "where did the day go?"<br/>
            Join thousands of happy, productive people<br/>
            daily in the #1 online coworking community.
          </p>

          <p>
            Beautiful music, AI Coaches, and videos and quotes to inspire you.
          </p>
        </div>

        <TryCenteredButton />
      </div>

      <Image
        src={PreviewImage}
        width={409}
        height={421}
        alt="App Preview"
        className="mx-auto md:-mr-20 -mb-20 rounded-t-md"
      />
    </div>
  )
}
